import Home from '../pages/index.vue'


const routers = [
    {
        path: '/src/pages/index',
        name: 'home',
        component: Home
    },
    // {
    //     path: '/src/pages/playCourse/index',
    //     name: 'playCourse',
    //     component: () => import('@/pages/playCourse/index'),
    // }
]
export default routers


// WEBPACK FOOTER //
// ./src/router/routers.js